import list from './saleCluePool'
export default list
